
// import LawyersSection from "../components/section/LawyersSection";
import LawFirmDashboard from "../components/section/LawFirmDashboard";
import PaymentHistory from "../components/section/PaymentHistory";

// Paralegal Pages
import ParalegalDashboard from "../components/admin/adminSections/ParalegalDashboard";
import ParalegalPersonalInfo from "../components/admin/adminSections/ParalegalPersonalInfo";
import ParalegalMyRequests from "../components/admin/adminSections/ParalegalMyRequests";
import ParalegaRequestChat from "../components/admin/adminSections/ParalegaRequestChat";

// Lawyer Pages 
import LawyerPersonalInfo from "../components/admin/adminSections/LawyerPersonalInfo";
import MyParalegals from "../components/admin/adminSections/MyParalegals";
import MyCustomer from "../components/admin/adminSections/MyCustomer";
import LawyerCreateClientRequest from "../components/admin/adminSections/LawyerCreateClientRequest";
import LawyerCreateClient from "../components/admin/adminSections/LawyerCreateClient";
import LawyerRequestChat from "../components/admin/adminSections/LawyerRequestChat";

// Client Pages
import ClientPersonalInfo from "../components/admin/adminSections/ClientPersonalInfo";
import ClientFormsManagement from "../components/admin/adminSections/ClientFormsManagement";
import MyTicket from "../components/admin/adminSections/MyTicket";
import ClientRequestChat from "../components/admin/adminSections/ClientRequestChat";
import MyPackages from "../components/admin/adminSections/MyPackages";

// Office Owner Pages
import OfficeOwnerDashboard from "../components/admin/adminSections/OfficeOwnerDashboard";
import OfficePersonalInfo from "../components/admin/adminSections/OfficePersonalInfo";
import OfficeDetails from "../components/admin/adminSections/OfficeDetails";
import MyLawyers from "../components/admin/adminSections/MyLawyers";
import OfficeAnalytics from "../components/admin/adminSections/OfficeAnalytics";
import OfficeLawyerRequests from "../components/admin/adminSections/OfficeLawyerRequests";
import MySubscriptions from "../components/admin/adminSections/MySubscriptions";
import CaseTypes from "../components/admin/adminSections/CaseTypes";
import OfficeCreateClient from "../components/admin/adminSections/OfficeCreateClient";
import OfficeCreateClientRequest from "../components/admin/adminSections/OfficeCreateClientRequest";

// For All Pages
import ChangePasswordAll from "../components/section/ChangePasswordAll";


export const contentConfig = {
    client: {
        personal: ({ userData, setUserData }) => (
            <ClientPersonalInfo userData={userData} setUserData={setUserData} />
        ),
        forms: () => <ClientFormsManagement />,
        packages: () => <MyPackages />,
        ticket: ({ userData }) => <MyTicket userData={userData} />,
        clientRequestChat: ({ userData }) => <ClientRequestChat userData={userData} />,
        password: ({ userData }) => <ChangePasswordAll userData={userData} />,
    },
    lawyer: {
        personal: ({ userData, setUserData }) => (
            <LawyerPersonalInfo userData={userData} setUserData={setUserData} />
        ),
        myCustomer: ({ userData }) => <MyCustomer userData={userData} />,
        myParalegals: ({ userData }) => <MyParalegals userData={userData} />,
        lawyerCreateClientRequest: ({ userData }) => <LawyerCreateClientRequest userData={userData} />,
        lawyerCreateClient: ({ userData }) => <LawyerCreateClient userData={userData} />,
        lawfirm: ({ userData, setUserData }) => (
            <LawFirmDashboard userData={userData} setUserData={setUserData} />
        ),
        payments: ({ userData }) => <PaymentHistory userData={userData} />,
        lawyerRequestChat: ({ userData }) => <LawyerRequestChat userData={userData} />,
        password: ({ userData }) => <ChangePasswordAll userData={userData} />,
    },
    office_owner: {
        dashboard: ({ userData, setUserData }) => (
            <OfficeOwnerDashboard userData={userData} setUserData={setUserData} />
        ),
        personal: ({ userData, setUserData }) => (
            <OfficePersonalInfo userData={userData} setUserData={setUserData} />
        ),
        officeDetails: ({ userData }) => <OfficeDetails userData={userData} />,
        myLawyers: ({ userData }) => <MyLawyers userData={userData} />,
        caseTypes: ({ userData }) => <CaseTypes userData={userData} />,
        officeCreateClientRequest: ({ userData }) => <OfficeCreateClientRequest userData={userData} />,
        officeCreateClient: ({ userData }) => <OfficeCreateClient userData={userData} />,
        oficeLawyerRequests: ({ userData }) => <OfficeLawyerRequests userData={userData} />,
        analytics: ({ userData }) => <OfficeAnalytics userData={userData} />,
        subscriptions: () => <MySubscriptions />,
        payments: ({ userData }) => <PaymentHistory userData={userData} />,
        password: ({ userData }) => <ChangePasswordAll userData={userData} />,
    },
    paralegal: {
        dashboard: ({ userData, setUserData }) => (
            <ParalegalDashboard userData={userData} setUserData={setUserData} />
        ),
        personal: ({ userData, setUserData }) => (
            <ParalegalPersonalInfo userData={userData} setUserData={setUserData} />
        ),
        myRequests: ({ userData }) => <ParalegalMyRequests userData={userData} />,
        paralegaRequestChat: ({ userData }) => <ParalegaRequestChat userData={userData} />,
        password: ({ userData }) => <ChangePasswordAll userData={userData} />,
    },
};
